import { Navbar, Container, Nav, NavDropdown, Col, Button, NavItem } from "react-bootstrap";
import { useState, useEffect, useRef } from "react";
import logo_baur from "./assets/logo_baur.svg";
import logo_immopilot from "./assets/Immopilot_Logo.png";
import Tutorial from "./Tutorial";
import SearchEstate from "./SearchEstate";
import { useConfig } from "./ConfigContext";
import { header, host } from "./globalVariables";
import { api } from "./pureFunctions";

export default function MyNavbar({ user }) {
   const config = useConfig();
   const [enableTutorial, setEnableTutorial] = useState(false);
   useEffect(() => {
      let params = new URLSearchParams(document.location.search);
      const url_id = params.get("estateid");
      // if(url_id==="3645") setEnableTutorial(true)
   }, []);
   useEffect(() => {
      console.log(user);
   }, [user]);

   const handleLogout = async () => {
      await api.post("/api/logout", {}, header).then((data) => {
         console.log(data);
         window.location.href = "/login";
      });
   };
   return (
      <>
         <Navbar className=" w-100 " expand="xl" data-bs-theme="dark">
            {/* <Container className="w-100"> */}

            <Navbar.Collapse id="basic-navbar-nav" className="w-100">
               <Navbar.Brand className="navbar-img-collapse">
                  <img
                     src={host + "/images/logo.png"}
                     // width="150"
                     height="50"
                     style={{
                        imageRendering: "-webkit-optimize-contrast",
                        imageRendering: "crisp-edges",
                     }}
                     className="d-inline-block align-top"
                     alt="Logo"
                     onClick={() => {
                        handleLogout();
                     }}
                  />
               </Navbar.Brand>

               {user && (
                  <>
                     <Nav className="me-auto">
                        <Nav.Link href="/immobilien">Immobilienliste</Nav.Link>

                        {config.company === "baur" && (
                           <>
                              <Nav.Link href="/projektstatus">Statusübersicht</Nav.Link>
                              <Nav.Link href="/adminterminbuchung">Terminbuchung</Nav.Link>
                              <Nav.Link href="/flowcharts">Telefonleitfäden</Nav.Link>
                              {["globaladmin", "admin"].includes(user.role) && (
                                 <Nav.Link href="/nutzerauswertung">Nutzerauswertung</Nav.Link>
                              )}

                              {(user.role === "globaladmin" || user.Name === "APetrich") && (
                                 <NavDropdown title="Statistik" id="statsDropdown">
                                    {user.role === "globaladmin" && (
                                       <NavDropdown.Item href="/verkaufstatistik">Verkauf</NavDropdown.Item>
                                    )}
                                    <NavDropdown.Divider />
                                    {user.role === "globaladmin" && (
                                       <NavDropdown.Item href="/einkaufstatistik">Einkauf</NavDropdown.Item>
                                    )}
                                    <NavDropdown.Item href="/verkaufsdaten">Verkaufsdaten</NavDropdown.Item>
                                 </NavDropdown>
                              )}
                              <NavDropdown title="Akquise" id="akquiseDropdown">
                                 <NavDropdown.Item href="/gutscheine">Veranstaltungen</NavDropdown.Item>
                                 <NavDropdown.Item href="/imv">IMV Import</NavDropdown.Item>
                                 <NavDropdown.Divider />
                                 <NavDropdown.Item href="/akquiseadressen">Akquise-Adressübersicht</NavDropdown.Item>
                                 <NavDropdown.Item href="/veranstaltungsadressen">VA-Adressübersicht</NavDropdown.Item>
                                 <NavDropdown.Item href="/Einkaufsterminkarte">Einkaufstermin-Karte</NavDropdown.Item>
                              </NavDropdown>
                              <NavDropdown title="Sonstiges" id="sonstigeDropdown">
                                 <NavDropdown.Item href="/bewertungsmappe">Bewertungsmappe</NavDropdown.Item>
                                 <NavDropdown.Item href="/leerstandkarte">Leerstand-Karte</NavDropdown.Item>
                                 <NavDropdown.Item href="/redact">Schwärzung</NavDropdown.Item>
                                 <NavDropdown.Item href="/buwogleads">BUWOG-Leads</NavDropdown.Item>
                              </NavDropdown>
                              {false && (
                                 <NavDropdown title="Externes" id="externe">
                                    {/* <NavDropdown.Item href="/auktionsubersicht?estateid=17355">Übersicht</NavDropdown.Item> */}
                                    <NavDropdown.Item href="/auktionsubersicht?estateid=0">
                                       Testauktion
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href="/funnel">Funnel</NavDropdown.Item>
                                    {/* <NavDropdown.Item href="/auktionserstellung">Erstellen</NavDropdown.Item> */}
                                 </NavDropdown>
                              )}
                              {["globaladmin", "admin"].includes(user.role) && (
                                 <NavDropdown title="Admin" id="adminDropdown">
                                    <NavDropdown.Item href="/nutzerverwaltung">Nutzerverwaltung</NavDropdown.Item>
                                 </NavDropdown>
                              )}
                           </>
                        )}
                        {config.company === "bender" && (
                           <>
                              <NavDropdown title="Tools" id="toolsDropdown">
                                 <NavDropdown.Item href="/redact">Schwärzung</NavDropdown.Item>
                              </NavDropdown>
                              {user.role === "globaladmin" && (
                                 <NavDropdown title="Statistik" id="statsDropdown">
                                    <NavDropdown.Item href="/nutzerauswertung">Nutzerauswertung</NavDropdown.Item>
                                    <NavDropdown.Item href="/verkaufsdaten">Verkaufsdaten</NavDropdown.Item>
                                 </NavDropdown>
                              )}
                              {user.Name === "jonathan.mischke" &&
                                 (user.role === "globaladmin" || user.role === "admin") && (
                                    <NavDropdown title="Admin" id="adminDropdown">
                                       <NavDropdown.Item href="/nutzerverwaltung">Nutzerverwaltung</NavDropdown.Item>
                                    </NavDropdown>
                                 )}
                           </>
                        )}
                     </Nav>
                  </>
               )}
               {/* <Col xs="auto">{enableTutorial && <Tutorial />}</Col> */}

               {config.company === "baur" && (
                  <Navbar.Brand className="navbar-img-collapse" style={{ position: "relative", right: "0px" }}>
                     <img src={logo_immopilot} height="26" className="d-inline-block align-top " alt="baur pilot" />
                  </Navbar.Brand>
               )}
            </Navbar.Collapse>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />

            <Navbar.Brand style={{ position: "relative", right: "24px" }}>
               <SearchEstate />
            </Navbar.Brand>
         </Navbar>
      </>
   );
}
